/** The logged-in person, when they are a real team member. A pure admin login has no resource row. */
export function staffResourceId(
  resource: { id?: string | null; auth_user_id?: string | null } | null | undefined,
): string | null {
  if (!resource?.id) return null;
  if (resource.auth_user_id && resource.id === resource.auth_user_id) return null;
  return resource.id;
}

/** Stamp a service or add-on that was put on a booking after it was created. */
export function upsellLineStamp(resourceId: string | null) {
  return {
    is_original: false,
    added_by: resourceId,
  };
}
